import { CALL_DURIATION_URL, CALL_LOG_URL, CALL_NOTIFICATION_URL, CHAT_SEARCH_BUYER_URL, CHAT_SEARCH_LIST_BUYER_URL, CHAT_SEARCH_SELLER_URL, PREVENT_LOGIN_PUSH_NOTIFICATION_URL } from "../../api";
import axiosInstance from "../../axiosInstance";


export const callDuration = (user, task_details) => onResponse => {

    try {
        axiosInstance.post(CALL_DURIATION_URL, { user: user, task_details: task_details })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const updateCallDuration = (user, task_details, duration) => onResponse => {

    try {
        axiosInstance.post(CALL_LOG_URL, { to_user: user, task_details: task_details, duration: duration })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const sendCallNotification = (user, link) => onResponse => {

    try {
        axiosInstance.post(CALL_NOTIFICATION_URL, { user: user, link: link })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};


export const preventLoginPushNotification = (status, token, is_chat) => onResponse => {
    let status_value = "False"
    if (status === true) {
        status_value = "True"
    }
    let chat_value = "False"
    if (is_chat === true) {
        chat_value = "True"
    }

    try {
        axiosInstance.get(PREVENT_LOGIN_PUSH_NOTIFICATION_URL + '?status=' + status_value + '&one_signal_token=' + token + '&in_chat=' + chat_value)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};